var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoMitchellsButlers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156.27528,
    height: 71.066437,
    viewBox: "0 0 41.347835 18.802995",
    id: "svg4953",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs4947"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath4682",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4680",
    d: "m 42.52,746.82 h 120.83 v 52.55 H 42.52 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath4654",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4652",
    d: "m 42.52,746.82 h 116.456 v 52.55 H 42.52 Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-65.636968,-180.87691)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g5218",
    transform: "translate(0.13229104,-0.13230417)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 101.07264,186.02087 -0.0254,-0.0977 c -1.59385,0.50941 -2.81305,1.88736 -3.033889,3.59481 0.09525,0.0339 0.191206,0.0646 0.287867,0.0917 0.103364,-1.54975 1.086203,-3.02542 2.771422,-3.58881",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.35277778
    },
    id: "path4658"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 103.70655,185.93543 c -0.002,0.0423 -0.005,0.0847 -0.009,0.12665 1.60725,0.56656 2.69875,2.10114 2.69875,3.81917 0,2.2232 -1.81822,4.03578 -4.05271,4.0319 -1.88066,-0.002 -3.912662,-1.45662 -4.045659,-3.78954 -0.107597,-0.0219 -0.214489,-0.0487 -0.319969,-0.0783 0,0.0127 -3.53e-4,0.0261 -3.53e-4,0.0392 0.0035,2.57916 2.103611,4.36033 4.371271,4.36033 2.30681,0 4.38538,-1.83515 4.37127,-4.36033 -0.0102,-1.93922 -1.25095,-3.58422 -3.01343,-4.14902",
    style: {
      fill: "#a50049",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.35277778
    },
    id: "path4662"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 102.34849,185.72549 -0.19861,0.006 0.004,0.10302 0.1972,-0.005 c 0.43109,0.002 0.84208,0.0695 1.22555,0.19085 0.004,-0.0402 0.008,-0.0804 0.0113,-0.121 -0.39159,-0.11324 -0.8068,-0.17463 -1.23931,-0.17392",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.35277778
    },
    id: "path4666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 103.6592,184.93252 -0.1076,0.013 c 0.03,0.20426 0.0512,0.41099 0.0512,0.61384 0,2.21403 -1.75402,4.19982 -4.208643,4.20299 -1.992136,0.003 -4.21005,-1.58362 -4.214283,-4.20299 -0.0049,-2.63102 2.225674,-4.21605 4.214283,-4.20406 1.103843,0.007 2.295873,0.50306 3.094563,1.3642 l 0.0751,-0.0748 c -0.86325,-0.97191 -2.09445,-1.50531 -3.363741,-1.50319 -2.489553,0.004 -4.51485,2.03588 -4.51485,4.53743 0,2.60667 2.108906,4.53637 4.51485,4.53637 2.779891,0 4.515201,-2.30611 4.515201,-4.53637 0,-0.27341 -0.0183,-0.51753 -0.0561,-0.74648",
    style: {
      fill: "#f67935",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.35277778
    },
    id: "path4670"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#706f73",
      fillOpacity: 1
    },
    id: "g5194"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4674",
    style: {
      fill: "#706f73",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.35277778
    },
    d: "m 77.344769,196.9349 c -0.209903,0.17039 -0.253294,0.30304 -0.303036,0.50729 -0.174625,0.72073 -0.382411,0.98919 -0.540808,1.18604 0.278694,0.38241 0.603955,0.68298 1.123244,0.80892 -0.131233,0.0924 -0.444853,0.22543 -0.723547,0.22543 -0.37712,0 -0.773289,-0.14993 -1.022703,-0.44944 -0.499533,0.3877 -1.067153,0.4632 -1.571978,0.46672 -0.944386,0.006 -1.558925,-0.47131 -1.557514,-1.10102 0.0011,-0.52317 0.1905,-0.87065 0.822325,-1.18286 l 0.448734,-0.22719 c -0.389467,-0.35454 -0.616656,-0.56374 -0.617361,-1.0167 -0.0011,-0.46955 0.46108,-0.9398 1.357489,-0.9398 0.764822,0 1.313744,0.30797 1.313744,0.93486 0,0.48965 -0.425097,0.73201 -0.913695,0.94509 0.412398,0.36618 0.625475,0.5849 1.035403,1.14229 0.174625,-0.21872 0.304447,-0.60748 0.328084,-0.85584 0.01623,-0.17533 0,-0.26846 -0.158045,-0.44379 z m -3.5941,1.49648 c 0,0.51118 0.453672,0.70485 0.971197,0.70485 0.227542,0 0.614892,-0.0984 0.877006,-0.30586 -0.338667,-0.48083 -0.732367,-0.92392 -1.196622,-1.33914 -0.564798,0.34572 -0.651581,0.59937 -0.651581,0.94015 m 1.061508,-1.63971 c 0.475192,-0.23459 0.529873,-0.48436 0.522464,-0.66463 -0.01058,-0.24836 -0.222603,-0.43568 -0.507294,-0.43745 -0.295981,-0.002 -0.55245,0.11572 -0.55245,0.43569 0,0.13723 0.09137,0.25611 0.271992,0.43673 l 0.265288,0.22966"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4686",
    style: {
      fill: "#706f73",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.35277778
    },
    d: "m 65.852186,189.75273 c 0,-0.24095 -0.1143,-0.35454 -0.215194,-0.43109 h 1.325738 l 1.56457,3.07375 1.565275,-3.07375 h 1.281289 c -0.100895,0.0765 -0.215548,0.19014 -0.215548,0.43109 v 3.44629 c 0,0.23565 0.121356,0.34254 0.215548,0.4191 H 70.0513 c 0.08749,-0.0766 0.215194,-0.18345 0.215194,-0.4191 v -2.84798 h -0.01376 l -1.667933,3.26708 h -0.430036 l -1.667228,-3.26778 -0.0099,-10e-4 v 2.8501 c 0,0.23565 0.1143,0.34254 0.208492,0.4191 h -1.049161 c 0.08749,-0.0766 0.215194,-0.18345 0.215194,-0.4191 v -3.44629"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4690",
    style: {
      fill: "#706f73",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.35277778
    },
    d: "m 72.28008,191.06793 c 0,-0.20779 -0.127706,-0.34149 -0.215547,-0.41981 h 1.090083 v 2.56823 c 0,0.22472 0.121003,0.32914 0.215195,0.40181 h -1.305278 c 0.08784,-0.0727 0.215547,-0.17709 0.215547,-0.40181 z m -0.154517,-1.24848 c 0,-0.25012 0.225073,-0.50871 0.524934,-0.50871 0.274814,0 0.524933,0.25859 0.524933,0.50871 0,0.30445 -0.250119,0.5394 -0.524933,0.5394 -0.299861,0 -0.524934,-0.23495 -0.524934,-0.5394"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4694",
    style: {
      fill: "#706f73",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.35277778
    },
    d: "m 79.468632,193.39968 c -0.282575,0.16228 -0.545042,0.30268 -1.008944,0.30268 -1.176867,0 -1.715206,-0.74753 -1.715206,-1.58044 0,-0.85796 0.7112,-1.56245 1.701447,-1.55822 0.409928,0.002 0.591961,0.15699 0.773642,0.15699 0.134408,0 0.156986,-0.0734 0.188736,-0.1009 v 0.84843 c -0.188736,-0.19685 -0.397228,-0.39617 -0.841022,-0.39617 -0.639234,0 -0.948267,0.53975 -0.948267,1.05551 0,0.60608 0.366536,1.07845 1.008945,1.07845 0.437091,0 0.679097,-0.19439 0.840669,-0.38524 v 0.57891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4698",
    style: {
      fill: "#706f73",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.35277778
    },
    d: "m 80.267356,189.43658 c 0,-0.21872 -0.127706,-0.31009 -0.215194,-0.38276 h 1.08973 v 2.04646 h 0.02681 c 0.172861,-0.22084 0.506589,-0.53658 1.150409,-0.53658 0.91828,0 0.934861,0.81457 0.934861,1.13736 v 1.51553 c 0,0.22437 0.121002,0.32879 0.215194,0.40146 h -1.304925 c 0.08749,-0.0727 0.215547,-0.17709 0.215547,-0.40146 v -1.59102 c 0,-0.22437 -0.05256,-0.50977 -0.470958,-0.51365 -0.350308,-0.004 -0.652639,0.34431 -0.766939,0.55175 v 1.55292 c 0,0.22437 0.121003,0.32879 0.215195,0.40146 h -1.304925 c 0.08749,-0.0727 0.215194,-0.17709 0.215194,-0.40146 v -3.78001"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4702",
    style: {
      fill: "#706f73",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.35277778
    },
    d: "m 90.1046,189.47436 c 0,-0.21837 -0.128058,-0.34749 -0.215547,-0.42051 h 1.08973 v 4.16278 c 0,0.22436 0.121356,0.32879 0.215195,0.40146 h -1.304925 c 0.08749,-0.0727 0.215547,-0.1771 0.215547,-0.40146 v -3.74227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4706",
    style: {
      fill: "#706f73",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.35277778
    },
    d: "m 84.196807,197.02832 c 0,-0.21872 -0.1143,-0.34325 -0.208139,-0.42192 h 1.082322 v 1.9498 c 0,0.33937 0.107598,0.55774 0.430389,0.55774 0.666045,0 0.800453,-0.72884 0.800453,-1.24425 v -0.84137 c 0,-0.21872 -0.127706,-0.3489 -0.215194,-0.42192 h 1.089377 v 2.02776 c 0,0.53623 0.04022,0.69921 0.174978,0.9458 H 86.47681 c -0.06738,-0.15981 -0.0949,-0.33443 -0.1143,-0.48048 h -0.01376 c -0.198261,0.34325 -0.587727,0.56409 -1.170163,0.56409 -0.779992,0 -0.981781,-0.54963 -0.981781,-1.14406 v -1.49119"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4710",
    style: {
      fill: "#706f73",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.35277778
    },
    d: "m 91.123351,195.45295 c 0,-0.21872 -0.128058,-0.34678 -0.215194,-0.41981 h 1.08973 v 4.13244 c 0,0.22437 0.121003,0.34149 0.214842,0.41452 h -1.304572 c 0.08714,-0.073 0.215194,-0.19015 0.215194,-0.41452 v -3.71263"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4714",
    style: {
      fill: "#706f73",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.35277778
    },
    d: "m 96.981826,197.04052 c 0,-0.21837 -0.128058,-0.36019 -0.215547,-0.43251 h 1.08973 v 0.61066 h 0.01341 c 0.183092,-0.34184 0.487892,-0.70732 1.055864,-0.69426 0.141111,0.004 0.288925,0.0339 0.430389,0.0674 v 0.69497 c -0.08714,-0.0787 -0.195086,-0.22966 -0.50412,-0.22966 -0.500591,0 -0.717197,0.41593 -0.995539,0.8068 v 1.30175 c 0,0.22437 0.121003,0.34149 0.215548,0.41452 h -1.305278 c 0.08749,-0.073 0.215547,-0.19015 0.215547,-0.41452 v -2.12513"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4718",
    style: {
      fill: "#706f73",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.35277778
    },
    d: "m 91.924862,192.71021 c 0.248708,0.21872 0.625475,0.50024 1.190625,0.50024 0.410281,0 0.719667,-0.0854 0.719667,-0.37148 0,-0.63852 -2.017889,-0.24094 -2.017889,-1.3843 0,-0.58843 0.665691,-0.89111 1.325033,-0.89111 0.591608,0 0.854075,0.13441 1.083028,0.13441 0.09419,0 0.18168,-0.0557 0.242358,-0.0843 v 0.85831 c -0.161925,-0.15734 -0.592314,-0.42298 -1.096786,-0.42298 -0.423333,0 -0.67945,0.10336 -0.67945,0.34996 0,0.58278 2.017889,0.18485 2.017889,1.36172 0,0.54892 -0.584906,0.94156 -1.425928,0.94156 -0.571853,0 -1.055864,-0.17956 -1.183216,-0.17956 -0.06773,0 -0.121709,0.0617 -0.175331,0.0952 v -0.9077"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4722",
    style: {
      fill: "#706f73",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.35277778
    },
    d: "m 99.877426,198.67103 c 0.248704,0.21872 0.625124,0.50024 1.190624,0.50024 0.41028,0 0.71967,-0.085 0.71967,-0.37077 0,-0.63923 -2.018244,-0.24095 -2.018244,-1.38465 0,-0.58844 0.666044,-0.89147 1.325384,-0.89147 0.59161,0 0.85408,0.13476 1.08268,0.13476 0.0938,0 0.18168,-0.0565 0.24236,-0.0843 v 0.85761 c -0.16158,-0.15664 -0.59232,-0.42228 -1.09609,-0.42228 -0.42403,0 -0.6798,0.10301 -0.6798,0.34925 0,0.58314 2.01754,0.18521 2.01754,1.36243 0,0.54927 -0.58491,0.94192 -1.42558,0.94192 -0.5722,0 -1.05586,-0.17992 -1.18357,-0.17992 -0.06738,0 -0.120999,0.0617 -0.174974,0.0952 V 198.671"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4726",
    style: {
      fill: "#706f73",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.35277778
    },
    d: "m 79.586389,195.72562 c -0.0025,-0.2413 -0.117475,-0.36689 -0.218017,-0.44344 h 1.811514 c 0.651228,-3.5e-4 1.915231,0 1.910292,1.02376 -0.0032,0.64629 -0.480131,0.95673 -0.970845,0.99765 v 0.012 c 0.544689,0.0176 1.307042,0.24483 1.307042,1.10984 0,1.10631 -1.439333,1.15393 -2.246489,1.15393 h -1.811514 c 0.09419,-0.0769 0.215548,-0.17215 0.218017,-0.4071 z m 1.593497,1.37936 c 0.575734,0.0229 0.974372,-0.20426 0.974372,-0.64594 0,-0.50059 -0.380647,-0.66886 -0.980722,-0.66498 l -0.690033,3.5e-4 v 1.31057 z m 0,1.96533 c 0.578556,-0.005 1.311981,-0.13194 1.311981,-0.74966 0,-0.67098 -0.733425,-0.72601 -1.311981,-0.71437 h -0.696383 v 1.46403 h 0.696383"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4730",
    style: {
      fill: "#706f73",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.35277778
    },
    d: "m 96.059242,199.28169 c -0.392642,0.22154 -0.732719,0.38135 -1.399117,0.38135 -1.123244,0 -1.839383,-0.59831 -1.839383,-1.59667 0,-0.96097 0.729544,-1.54199 1.7653,-1.54199 1.325739,0 1.560689,0.93098 1.560689,1.70321 h -2.428522 c 0.0021,0.27799 0.20708,0.9331 1.115483,0.9331 0.699911,0 1.003653,-0.32703 1.226256,-0.55139 z m -0.753181,-1.49542 c -0.02681,-0.2794 -0.134408,-0.76694 -0.780344,-0.76694 -0.594078,-3.6e-4 -0.790575,0.41416 -0.807508,0.76694 h 1.587852"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4734",
    style: {
      fill: "#706f73",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.35277778
    },
    d: "M 88.268427,197.10896 H 87.81793 v -0.50236 h 0.450497 v -0.63782 l 0.874183,-0.21202 v 0.84984 h 1.109839 v 0.50236 H 89.14261 v 1.51871 c 0,0.22966 0.06068,0.53234 0.443795,0.53234 0.329847,0 0.52458,-0.12806 0.678039,-0.29704 v 0.58879 c -0.298098,0.13934 -0.543278,0.21025 -0.846314,0.21025 -0.887236,0 -1.149703,-0.29668 -1.149703,-1.16593 v -1.38712"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4738",
    style: {
      fill: "#706f73",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.35277778
    },
    d: "m 87.250804,193.32094 c -0.391936,0.22119 -0.732367,0.38135 -1.398411,0.38135 -1.123244,0 -1.839031,-0.59831 -1.839031,-1.59667 0,-0.96097 0.728839,-1.54164 1.7653,-1.54164 1.325034,0 1.559984,0.93028 1.559984,1.70286 h -2.427817 c 0.0021,0.27799 0.206728,0.9331 1.114778,0.9331 0.699911,0 1.004005,-0.32667 1.225903,-0.55139 z m -0.752475,-1.49578 c -0.02716,-0.27904 -0.134408,-0.76658 -0.780344,-0.76658 -0.594078,0 -0.790575,0.41451 -0.807156,0.76658 h 1.5875"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4742",
    style: {
      fill: "#706f73",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.35277778
    },
    d: "m 74.249073,191.14892 h -0.45085 v -0.50094 h 0.45085 v -0.63853 l 0.874183,-0.21273 v 0.85126 h 1.109839 v 0.50094 h -1.109839 v 1.51906 c 0,0.22966 0.06068,0.53199 0.443795,0.53199 0.329847,0 0.52458,-0.12735 0.678039,-0.29669 v 0.58844 c -0.298098,0.1397 -0.543631,0.21061 -0.845961,0.21061 -0.887942,0 -1.150056,-0.29704 -1.150056,-1.16558 v -1.38783"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4746",
    style: {
      fill: "#706f73",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.35277778
    },
    d: "m 88.183231,189.47436 c 0,-0.21837 -0.127706,-0.34749 -0.214842,-0.42051 h 1.089378 v 4.16278 c 0,0.22436 0.121003,0.32879 0.215195,0.40146 h -1.304573 c 0.08714,-0.0727 0.214842,-0.1771 0.214842,-0.40146 v -3.74227"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMitchellsButlers);
export default __webpack_public_path__ + "static/media/logo-mitchells-butlers.0ec903280421d066a45090b74432f9ec.svg";
export { ForwardRef as ReactComponent };